<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    :title="'提示'"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <div class="marketInfo" v-if="marketInfo">
      <div class="dialog-intro">
        当前应用状态暂不支持访问，请联系商家处理后再尝试进入。
      </div>
      <div class="dialog-summary-grid">
        <div class="dialog-summary-item">
          <strong>商家</strong>
          <span>{{ marketInfo.marketName || '-' }}</span>
        </div>
        <div class="dialog-summary-item">
          <strong>联系人</strong>
          <span>{{ marketInfo.marketContactPerson || '-' }}</span>
        </div>
        <div class="dialog-summary-item">
          <strong>电话</strong>
          <span>{{ marketInfo.marketContactPhone || '-' }}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="handleClose"
        :loading="Loading"
        >关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAppDetailApi } from '@/api/appStore';
import { fetchCustomerList, fetchDeliveryList } from '@/api/customer';

export default {
  name: 'MerchantsInfo',
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    marketInfo: {
      type: Object,
      default: () => {
        return { contactName: '', contactPhone: '' };
      }
    }
  },
  data() {
    return {
      Loading: false
    };
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.marketInfo {
  padding-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/MerchantsInfo/index.vue